import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-folder-minus-icon',
  templateUrl: 'folder-minus-icon.component.html'
})
export class FolderMinusIconComponent {
  constructor() {}
}
